import ChatApp from './components/ChatApp';
import './styles/globals.css';

function App() {
  return <ChatApp />;
}

export default App;